"use client";

import { type ReactNode, createContext } from "react";

export const TimezoneScopeContext = createContext<string | null>(null);

/**
 * Puts a subtree on one location's clock. A screen about a single location —
 * an appointment booked there, that location's shift rows — reads and writes
 * times in its zone, whatever the viewer's own clock is: `useTimezone()` and
 * `useClinicClock()` beneath it return this zone. Show `TimezoneNotice` inside
 * it so the difference is never silent.
 */
export function TimezoneScope({
  timeZone,
  children,
}: {
  timeZone: string;
  children: ReactNode;
}) {
  return (
    <TimezoneScopeContext.Provider value={timeZone}>
      {children}
    </TimezoneScopeContext.Provider>
  );
}
